<template>
    <main class="phucha">
      <div class="bb-container bb-container--lista">
        <Notification
          tipo="success"
          ico="uil-check"
          v-if="successMessage"
          @close-notification="successMessage = ''"          
        >
          <span v-html="successMessage"></span>
        </Notification>
  
        <Notification tipo="primary" v-if="infoMessage" @close-notification="infoMessage = ''">
          {{ infoMessage }}
        </Notification>
  
        <Notification tipo="error" v-if="errorMessage"
                      @close-notification="errorMessage = ''">
          {{ errorMessage }}
        </Notification>

        <bbButton
          id="add-fund-button"
          class="button button--outline-dark button--sm"
          @click="addFund"
          :label="$t('constructor.addFund')"
          v-show="isApp"
        >
        </bbButton>
        
        <section class="phucha__container">
          <HuchaListadoAportacionesSkeleton v-show="!loaded" />
          <HuchaListadoAportaciones
            v-show="payouts.length > 0"
            :payouts="payouts"
            :accountOwner="user.name"
            v-if="contributions.length > 0"
          />
          <HuchaListado
            :contributions="contributions"
            v-if="contributions.length > 0 && loaded"
          />
          <HuchaVacia v-else />
          <AddFund ref="refAddButton" />
        </section>
      </div>
    </main>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import HuchaVacia from "./components/HuchaVacia.vue";
  import HuchaListado from "./components/HuchaListado.vue";
  import HuchaListadoAportaciones from "./components/HuchaListadoAportaciones.vue";
  import HuchaListadoAportacionesSkeleton from "./skeleton/HuchaListadoAportacionesSkeleton.vue";
  import Notification from "../../components/ui/Notification.vue";
  import AddFund from "../constructor/components/AddFund.vue";
  import bbButton from "../../components/buttons/bbButton.vue";
  
  export default {
    name: "HuchaAlt",
    components: {
      HuchaVacia,
      HuchaListado,
      HuchaListadoAportaciones,
      HuchaListadoAportacionesSkeleton,
      Notification,
      AddFund,
      bbButton,
    },
    data() {
      return {
        huchaLlena: true,
        showVerificar: false,
        showVerificando: false,
        showActivada: false,
        hasExternalAccount: "",
        verifiedStatus: "undefined",
        payoutAvailable: 0,
        amountTotal: 0,
        pendingAmount: 0,
        currency: null,
        accountView: null,
        contributions: [],
        payouts: [],
        loaded: false,
        showPendingVerificationModal: false,
        showVerifiedAccountModal: false,
        pendingPayments: false,
        errorMessage: "",
        infoMessage: "",
        successMessage: "",
      };
    },
    computed: {
      ...mapGetters({
        user: "user",
        isApp: "isApp",
      })
    },
    methods: {
      async preparePage() {
        //this.payoutAvailable = this.accountView.balance.payoutAvailable;
        //this.amountTotal = this.accountView.balance.amountTotal;
        //this.pendingAmount = this.accountView.balance.payoutPending;
        this.currency = {
          symbol: this.user.currencySymbol
        };
        
        //this.contributions = this.accountView.contributions;
        try{
          const result = await this.$store.dispatch("getUserContributions");
          this.contributions = result;
        }
        catch (error) {
          console.error("Error fetching contributions:", error);
          this.contributions = [];
        }

        this.contributions = this.adaptResponse(this.contributions);
        
        //this.payouts = this.accountView.payouts;
        this.payouts = [];
        //this.pendingPayments = this.accountView.balance.payoutPending > 0;
        this.loaded = true;
      },
      adaptResponse(contributions) {
        const culture = this.$i18n.locale
        console.log("Culture:", culture);

        return contributions.map(group => {
          const [yearStr, monthStr] = group.month.split("-");
          const year = parseInt(yearStr);
          const month = parseInt(monthStr);

          return {
            ...group,
            year,
            month,
            monthText: new Date(`${group.month}-01`).toLocaleString(culture, { month: 'long' }),
            payments: group.payments.map(p => ({
              ...p,
              createtAtString: new Date(p.createdAt).toLocaleDateString("culture")
            })),
          };
        });
      },
      addFund() {
        this.$refs.refAddButton.addFund();
      },
    },
    async mounted() {
      //if user has stripeAccountId, redirect to old hucha
      if (this.user.stripeAccountId) {
        this.$router.push({ name: "hucha" });
        return;
      }
      
      //if there is no payment method, redirect to hucha-crear
      if (!this.user.contributionMethods || this.user.contributionMethods.length === 0) {
        this.$router.push({ name: "hucha-crear" });
        return;
      }
      //if there is a query param 'from' and its value is 'settings', show the alert
      if (this.$route.query.from === "settings") {
        this.successMessage = this.$t("piggybank.contributionMethodSetUp")
      }
    },
    beforeRouteEnter(to, from, next) {
      // This will be called before the component is created
      // It has access to `this` once the component is created
      next(vm => {
        // Perform any logic here
        vm.preparePage();
      });
    }
  };
  </script>
  
  <style lang="scss" scoped></style>
